import { Link, useRouteLoaderData } from 'react-router'
import { useOptionalUser } from '#app/utils/user'
import { ProjectDropdown } from './project-dropdown'
import { UserDropdown } from './user-dropdown'

export default function Header() {
	const user = useOptionalUser()
	const appName = useRouteLoaderData('root')?.ENV.APP_NAME

	return (
		<header className="relative z-10 bg-gradient-to-r from-purple-600 to-indigo-600 text-white shadow-lg after:absolute after:bottom-0 after:left-0 after:h-8 after:w-full after:translate-y-full after:bg-gradient-to-b after:from-indigo-600/20 after:to-transparent">
			<div className="container mx-auto flex items-center justify-between px-4 py-3">
				<div className="flex items-center gap-2">
					<Link to="/" className="flex items-center gap-2">
						<img
							src="/img/logo/logo.png"
							alt="InSelect Logo"
							className="h-8 w-8"
						/>
						<span className="hidden text-2xl font-bold tracking-tight sm:block">
							{appName}
						</span>
					</Link>
				</div>

				{/* <nav className="hidden items-center space-x-6 md:flex"> */}
				<nav>
					{!user ? (
						<div className="hidden items-center gap-6 md:flex">
							<Link
								to="/#features"
								className="text-sm font-medium transition hover:text-purple-200"
							>
								Features
							</Link>
							<Link
								to="/#how-it-works"
								className="text-sm font-medium transition hover:text-purple-200"
							>
								How It Works
							</Link>
							<Link
								to="/#pricing"
								className="text-sm font-medium transition hover:text-purple-200"
							>
								Pricing
							</Link>
							<Link
								to="/updates"
								className="text-sm font-medium transition hover:text-purple-200"
							>
								Updates
							</Link>
						</div>
					) : (
						<ProjectDropdown />
					)}
				</nav>

				<div className="flex items-center gap-4">
					{user ? (
						<UserDropdown />
					) : (
						<Link
							to="/login"
							className="rounded-md bg-white px-4 py-2 text-sm font-medium text-indigo-600 transition hover:bg-purple-100"
						>
							Login
						</Link>
					)}
				</div>
			</div>
		</header>
	)
}
